/* eslint-disable no-lone-blocks */
<template>
<div>
  <h1>xx</h1>
    <div id="chart-container-dialog"></div>
</div>
</template>

<script>
import $ from 'jquery'
const axios = require('axios')
// const html2canvas = require('html2canvas');
// const FileSaver = require('file-saver');
export default {
  props: {
    resource: Object
  },
  created () {
    // console.log('this.resource', this.resource)
    this.createChartDialog(this.resource)
  },
  methods: {
    async getBase64Profile (filePath) {
      let result = [{ base64: '' }]
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/orgChart/getBase64ByPart`,
        method: 'POST',
        data: {
          listPart: [
            { img: filePath }
          ]
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            result = response.data.result[0].base64
          } else {
            result = [{ base64: '' }]
          }
        })
        .catch(function (thrown) {
          result = [{ base64: '' }]
        })
      return result
    },
    async modifyKeys (obj) {
      for (var key in obj) {
        if (obj[key] !== null) {
          if (key === 'img' && obj.img !== null) {
            obj.img = 'uploads/62149.jpg'
            const img64 = await this.getBase64Profile(obj.img)
            obj.img64 = 'data:image/jpeg;base64,' + img64.toString()
          }
          if (typeof obj[key] === 'object') {
            await this.modifyKeys(obj[key])
          }
        }
      }
    },
    nodeTemplate (datasource) {
      // eslint-disable-next-line no-lone-blocks
      {
        const cssProfileImage = `
          width: 6vw;
          height: 6vw;
          max-width: 6vw !important;
          object-fit: cover;
          border-radius: 50%;
          border : solid;
          border-color: #D3D3D3;
        `
        const cssNode = `
        font-family: arial, verdana, tahoma;
        display: inline-block;
        padding: 10px 10px;
        min-width: 250px;
        border-radius: 6px;
        border : solid;
        border-color: #D3D3D3;
        box-shadow: 0 1px 3px rgba(black, 0.12), 0 1px 2px rgba(black, 0.24);
        `
        const imagUI = datasource.img === undefined ? '' : `<img src="${datasource.img64}" style="${cssProfileImage}"/>`

        return `
        <div style="
        ${cssNode}
        ">
          <div class="custom-user">
            ${imagUI}
            <p style="
              font-size: 18px;
              font-weight: 100;
              word-wrap: break-word;
              text-align: center;
            ">${datasource.name || ''}</p>
            <p style="
              font-size: 19px;
              font-weight: 100;
              white-space: pre-wrap;
              word-wrap: break-word;
              text-align: center;
            ">${datasource.title || ''}</p>
          </div>
        </div>
        `
      }
    },
    async createChartDialog (data) {
      // console.log('createChart')
      var oc = $('#chart-container-dialog').orgchart({
        // chartClass: 'chart-custom',
        data: data,
        nodeTitle: 'name',
        // nodeContent: 'title',
        // nodeId: 'id',
        // parentNodeSymbol: 'pid',
        verticalLevel: 8,
        // visibleLevel: 6,
        // 'direction': 'b2t',
        // 'direction': 'l2r',
        // 'depth': 1,
        // 'verticalDepth': 3,
        pan: true,
        zoom: false,
        // zoominLimit: 3,
        // zoomoutLimit: 1,
        draggable: false,
        parentNodeSymbol: 'fa-users',
        // 'toggleSiblingsResp': true,
        // toggleSiblingsResp: false,
        nodeTemplate: this.nodeTemplate,
        exportButton: false,
        exportFilename: 'orgchart',
        exportFileextension: 'png',
        initCompleted: function () {
          setTimeout(function () {
            // center the chart to container
            var $container = $('#chart-container-dialog')
            $container.scrollLeft(($container[0].scrollWidth - $container.width()) / 2)
            // $container.scrollTop($container.height()/3);
            // console.log($container.height()/2)
            // console.log("scroll to center "+$container[0].scrollWidth);
            // get "zoom" and make usable
            // var $chart = $('.orgchart')
            // $chart.addClass('noncollapsable') // deactivate
            // $chart.css('transform', 'scale(1,1)')
            // var div = $chart.css('transform')
            // var values = div.split('(')[1]
            // values = values.split(')')[0]
            // values = values.split(',')
            // var a = values[0]
            // var b = values[1]
            // var currentZoom = Math.sqrt(a * a + b * b)
            // var zoomval = 0.8
            // // console.log("current zoom "+currentZoom);
            // var zoomCount = 0

            // zoomval = 0.6295000000000002
            // currentZoom = zoomval
            // $chart.css('transform', div + ' scale(' + zoomval + ',' + zoomval + ')')
            // // $chart.css("transform",'matrix(1, 0, 0, 1, 0,0)');
            // $chart.css('top', (($container.height() - $chart.outerHeight()) / 2) + $container.scrollTop() + 'px')
            // $chart.css('left', (($container.width() - $chart.outerWidth()) / 2) + $container.scrollLeft() + 'px')
            $container.scrollTop(2000)
          }, 100)
        }
      })
      console.log(oc)
    }
  }
}
</script>
